/**
 * Custom event types for filter synchronization
 * These events are used to communicate between multiple FilterComponentGroup instances
 */
export const FILTER_SYNC_EVENTS = {
  /** Emitted when a state is selected or deselected */
  STATE_SELECTED: 'filter-sync-state-selected',
  /** Emitted when insurance is selected or deselected */
  INSURANCE_SELECTED: 'filter-sync-insurance-selected',
  /** Emitted when needs/specialties are selected or deselected */
  NEEDS_SELECTED: 'filter-sync-needs-selected',
  /** Emitted when type of care changes (talk therapy, medication, both) */
  TYPE_OF_CARE_CHANGED: 'filter-sync-type-of-care-changed',
  /** Emitted when validation errors are updated */
  VALIDATION_UPDATED: 'filter-sync-validation-updated',
} as const;

/**
 * Internal event emitter event types
 * These are used within the useFilterSync hook for internal communication
 */
export const FILTER_EVENT_EMITTER_TYPES = {
  /** Internal event for state changes */
  STATE_SELECTED: 'state-selected',
  /** Internal event for insurance changes */
  INSURANCE_SELECTED: 'insurance-selected',
  /** Internal event for needs changes */
  NEEDS_SELECTED: 'needs-selected',
  /** Internal event for type of care changes */
  TYPE_OF_CARE_CHANGED: 'type-of-care-changed',
  /** Internal event for validation updates */
  VALIDATION_UPDATED: 'validation-updated',
} as const;

export type FilterSyncEventType = typeof FILTER_SYNC_EVENTS[keyof typeof FILTER_SYNC_EVENTS];
export type FilterEventEmitterType = typeof FILTER_EVENT_EMITTER_TYPES[keyof typeof FILTER_EVENT_EMITTER_TYPES]; 
